<div class="tree-field" [class.is-valid]="isValid()" [class.is-invalid]="isInvalid()">
    @if (anyExpanded()) {
        <button class="btn pace-link collapse-all" type="button" [disabled]="!editable()" (click)="collapseAll()">
            Collapse all
        </button>
    }
    <div role="tree" [attr.aria-label]="ariaLabel()" [attr.aria-multiselectable]="isMultiSelect()">
        <ng-container *ngTemplateOutlet="branch; context: { nodes: nodes() }"></ng-container>
    </div>
</div>

<ng-template #branch let-nodes="nodes">
    <ul class="internal-tree">
        @for (node of nodes; track node.value) {
            <li
                role="treeitem"
                [attr.aria-expanded]="hasChildren(node) ? isExpanded(node) : undefined"
                [attr.aria-selected]="hasChildren(node) ? undefined : isSelected(node)"
                [attr.aria-disabled]="node.disabled ? true : undefined"
            >
                <button
                    class="value-container"
                    type="button"
                    [class.leaf]="!hasChildren(node)"
                    [disabled]="!editable() || node.disabled"
                    (click)="activate(node)"
                >
                    @if (hasChildren(node)) {
                        <span class="caret" [class.caret-down]="isExpanded(node)" aria-hidden="true"></span>
                        <span class="checkbox-container has-children">
                            @if (hasSelectedDescendant(node)) {
                                <fa-icon [icon]="faCheck" size="2x"></fa-icon>
                            }
                        </span>
                    } @else {
                        <span class="checkbox-container">
                            @if (isSelected(node)) {
                                <fa-icon [icon]="faCheck" size="2x"></fa-icon>
                            }
                        </span>
                    }
                    <span class="node-label">{{ node.label }}</span>
                </button>

                @if (hasChildren(node) && isExpanded(node)) {
                    <ng-container *ngTemplateOutlet="branch; context: { nodes: node.children }"></ng-container>
                }
            </li>
        }
    </ul>
</ng-template>

@if (hasErrorMessages()) {
    <div class="invalid-feedback d-block">
        @for (error of errors(); track error.kind) {
            <div>{{ error.message ?? error.kind }}</div>
        }
    </div>
}
